import { cn } from '@/lib/utils';
import type { EstadoVenta } from '@adelante/shared';

/** Metadatos de cada estado de venta: letra, etiqueta y colores. */
export const VENTA_META: Record<
  EstadoVenta,
  { letra: string; label: string; chip: string; dot: string }
> = {
  formalizada: {
    letra: 'F',
    label: 'Formalizada',
    chip: 'border-emerald-300 bg-emerald-100 text-emerald-700',
    dot: 'bg-emerald-500',
  },
  reservada: {
    letra: 'R',
    label: 'Reservada',
    chip: 'border-amber-300 bg-amber-100 text-amber-700',
    dot: 'bg-amber-500',
  },
  entregada: {
    letra: 'E',
    label: 'Entregada',
    chip: 'border-sky-300 bg-sky-100 text-sky-700',
    dot: 'bg-sky-500',
  },
  disponible: {
    letra: 'D',
    label: 'Disponible',
    chip: 'border-zinc-300 bg-zinc-100 text-zinc-600',
    dot: 'bg-zinc-400',
  },
};

/** Insignia chiquita con la letra del estado de venta (F/R/D/E). */
export function BadgeVenta({
  estado,
  className,
}: {
  estado: EstadoVenta | null | undefined;
  className?: string;
}) {
  if (!estado) return null;
  const m = VENTA_META[estado];
  return (
    <span
      title={`Venta: ${m.label}`}
      className={cn(
        'inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border text-[10px] font-bold',
        m.chip,
        className,
      )}
    >
      {m.letra}
    </span>
  );
}
